module.exports = __webpack_public_path__ + "img/pie-chart.e866ecc9.png";